import { Box } from '@radix-ui/themes';
import { MediaProvider, useMediaRemote } from '@vidstack/react';

export const SmartPlayerViewport = () => {
    const remote = useMediaRemote();

    return (
        <Box
            onClick={() => remote.togglePaused()}
            style={{
                backgroundColor: 'black',
                borderRadius: 'var(--radius-3)',
                overflow: 'hidden',
                position: 'relative',
                width: '100%',
                height: '100%',
                cursor: 'pointer',
            }}
        >
            <MediaProvider />
        </Box>
    );
};
